export function request(data) {
    return {
        type: 'TRADER_CHAT_DISABLE_CHAT_REQUEST',
        data
    };
}

export function error(errors) {
    return {
        type: 'TRADER_CHAT_DISABLE_CHAT_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'TRADER_CHAT_DISABLE_CHAT_FINISH',
        data
    };
}
